export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "download": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["내 QR코드 다운로드"])}
    }
  })
}
